import React from 'react';
import withIcon from '../utilities/withIcon';

const IconHeart = () => {
  return (
    <g>
      <path d="m14.72 2.4795a4.1282 4.1282 0 0 0 -5.84 0l-.8811.8805-.8809-.8805a4.1294 4.1294 0 0 0 -5.84 5.84l6.19 6.1914a.7509.7509 0 0 0 1.0615 0l6.1905-6.1916a4.1282 4.1282 0 0 0 0-5.84zm-1.0609 4.7793-5.6602 5.6612-5.66-5.6611a2.63 2.63 0 1 1 3.7186-3.7189l1.4111 1.4112a.75.75 0 0 0 1.0606 0l1.4108-1.4112a2.6912 2.6912 0 0 1 3.7188 0 2.6287 2.6287 0 0 1 0 3.7187z" />
    </g>
  );
};

export default withIcon(IconHeart);
